const SERVICE_MATCHERS = [
  [/diagn[oó]stico/i, "diagnostico-de-brechas"],
  [/implementaci[oó]n/i, "implementacion-de-sistemas-de-gestion"],
  [/auditor/i, "auditorias-internas"],
  [/certificaci[oó]n/i, "preparacion-para-certificaciones"],
  [/mantenimiento|mejora/i, "mantenimiento-y-mejora-de-sistemas"],
  [/capacitaci[oó]n|sensibilizaci[oó]n/i, "capacitacion-empresarial"],
  [/documentaci[oó]n|procesos|procedimientos|pol[ií]ticas/i, "diseno-y-documentacion-de-procesos"],
  [/riesgo/i, "gestion-de-riesgos"],
  [/consultor/i, "consultoria-personalizada"],
];

export function serviceSlugFor(label = "") {
  return SERVICE_MATCHERS.find(([pattern]) => pattern.test(label))?.[1] || null;
}
